export default __webpack_public_path__ + "static/media/me_blob.d8caa87c.png";